import { ModalV2 } from '@electricjs/arc';
import { SmartSearch, SmartSearchSelectOption } from '../SmartSearch';

const GlobalSearch = ({
  searchableData,
  isAdmin,
  organizationId,
  onCloseModal,
}: {
  searchableData: SmartSearchSelectOption[];
  isAdmin: boolean;
  organizationId: string;
  onCloseModal: () => void;
}) => {
  return (
    <ModalV2
      ariaLabelledby="global-search-modal"
      visible
      hide={onCloseModal}
      minHeight="fit-content"
      position="fixed"
      top="15vh">
      <SmartSearch
        searchableData={searchableData}
        isAdmin={isAdmin}
        organizationId={organizationId}
        isInsideModal
      />
    </ModalV2>
  );
};

export default GlobalSearch;
